import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface IspettoreLookupItem {
  value: string;
  label: string;
}

interface IspettoriLookupResponse {
  ispettori: IspettoreLookupItem[] | null;
}

@Injectable({ providedIn: 'root' })
export class IspettoriService {
  constructor(private http: HttpClient) {}

  getIspettori(): Observable<IspettoriLookupResponse> {
    return this.http.get<IspettoriLookupResponse>('api/lookup/ispettori');
  }
}
